import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'src/components'
import { mergeProps } from 'src/util'
import styles from './InputGroupAddon.scss'

const InputGroupAddon = ({ id, icon, color, children, right, disabled, as: Wrapper, ...domProps }) => (
  <Wrapper {...mergeProps()({ className: [styles.addon, styles[color], { [styles.disabled]: disabled }] }, domProps)}>
    {!!icon && <Icon icon={icon} fixedWidth />}
    {!!children && <span>{children}</span>}
  </Wrapper>
)

InputGroupAddon.defaultProps = {
  as: 'div',
}

InputGroupAddon.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.elementType,
  color: PropTypes.string,
  children: PropTypes.node,
  right: PropTypes.bool,
  disabled: PropTypes.bool,
  as: PropTypes.elementType,
}

export default InputGroupAddon
